module.exports = __webpack_public_path__ + "img/广州南沙经济开发区商务局.0f7faa4d.png";